import api from '@/api/api'

export default {
    async fetchBy(params) {
        try {
            let resp = await api.get(`/api/database-column-map`, { params })

            return resp.data
        } catch (err) {
            throw 'Error fetching Database Column Map'
        }
    },
}
